var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatarBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.202692 8.52359L0 12.0569L0.198738 15.4695C0.446767 19.7285 3.84062 23.188 8.21946 23.6454L11.133 23.9497C11.7841 24.0178 12.441 24.0167 13.0919 23.9467L15.7723 23.6582C20.1047 23.192 23.4693 19.7856 23.7586 15.5729L24 12.0569L23.7541 8.42199C23.4679 4.18934 20.0775 0.770708 15.7226 0.323365L13.0478 0.0486127C12.426 -0.0152562 11.7991 -0.0161929 11.1771 0.0458175L8.26729 0.335922C3.86691 0.774635 0.448102 4.24561 0.202692 8.52359Z",
    fill: "#C7DDF7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.18269 12.8203C5.27409 12.4046 5.7859 12.1275 6.29772 12.0236C6.77297 11.9196 7.28479 11.9196 7.70521 12.0928C8.71056 12.4912 8.52777 13.6689 7.52242 13.9807C6.64502 14.2405 4.9999 13.6689 5.18269 12.8203Z",
    fill: "#EAEFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.91367 13.3571C5.17672 13.3571 4.5793 12.8763 4.5793 12.2833C4.5793 11.6902 5.17672 11.2095 5.91367 11.2095C6.65063 11.2095 7.24805 11.6902 7.24805 12.2833C7.24805 12.8763 6.65063 13.3571 5.91367 13.3571Z",
    fill: "#EAEFF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.66573 12.7684C3.66573 13.1668 4.01303 13.4959 4.43345 13.4959C4.85387 13.4959 5.20117 13.1668 5.20117 12.7684C5.20117 12.3701 4.85387 12.041 4.43345 12.041C4.01303 12.041 3.66573 12.3701 3.66573 12.7684Z",
    fill: "#EAEFF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50704 13.0973C4.50704 13.7901 5.11025 14.3617 5.84141 14.3617C6.57257 14.3617 7.17578 13.7901 7.17578 13.0973C7.17578 12.4046 6.57257 11.833 5.84141 11.833C5.09197 11.8503 4.50704 12.4046 4.50704 13.0973Z",
    fill: "#EAEFF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5656 12.8718C18.4742 12.4561 17.9623 12.179 17.4505 12.0751C16.9753 11.9712 16.4635 11.9712 16.043 12.1443C15.0377 12.5427 15.2205 13.7204 16.2258 14.0322C17.1032 14.292 18.7301 13.7204 18.5656 12.8718Z",
    fill: "#EAEFF5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.816 13.4089C17.0791 13.4089 16.4816 12.9281 16.4816 12.335C16.4816 11.742 17.0791 11.2612 17.816 11.2612C18.553 11.2612 19.1504 11.742 19.1504 12.335C19.1504 12.9281 18.553 13.4089 17.816 13.4089Z",
    fill: "#EAEFF5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3153 13.5476C18.8913 13.5476 18.5476 13.2219 18.5476 12.8202C18.5476 12.4185 18.8913 12.0928 19.3153 12.0928C19.7393 12.0928 20.083 12.4185 20.083 12.8202C20.083 13.2219 19.7393 13.5476 19.3153 13.5476Z",
    fill: "#EAEFF5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6018 14.3796C16.8846 14.2191 16.4405 13.5381 16.6098 12.8586C16.7792 12.179 17.4979 11.7582 18.2151 11.9187C18.9323 12.0791 19.3764 12.7601 19.207 13.4397C19.0377 14.1192 18.319 14.54 17.6018 14.3796Z",
    fill: "#EAEFF5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1445 12.2361C10.8624 13.0782 12.89 13.0324 13.6062 12.21",
    stroke: "#1764D7",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52992 10.9476C8.17815 11.0075 8.76435 10.2801 8.56539 9.65971C8.36642 9.03928 7.46787 8.78469 6.97581 9.21043C6.48375 9.63618 6.59928 10.5625 7.18333 10.8492C7.28602 10.9006 7.41439 10.9369 7.52992 10.9476Z",
    fill: "#1764D7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9811 10.9476C16.6293 11.0075 17.2155 10.2801 17.0166 9.65971C16.8176 9.03928 15.919 8.78469 15.427 9.21043C14.9349 9.63618 15.0504 10.5625 15.6345 10.8492C15.7372 10.9006 15.8656 10.9369 15.9811 10.9476Z",
    fill: "#1764D7"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarBlue);
export default __webpack_public_path__ + "static/media/avatar-blue.137d45e2f3ae8175d0e83011449dfc03.svg";
export { ForwardRef as ReactComponent };